import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { FilesAPI } from 'api/files';
import { GENERAL_API_STALE } from 'config/query-config';
export const getFileGroupsQueryKey = (source)=>[
        'file-groups',
        'by-source',
        source.sourceType,
        source.sourceId
    ];
export const useFileGroupsQuery = (source)=>useQuery(getFileGroupsQueryKey(source), ()=>FilesAPI.getFileGroups(source));
export const getFileGroupsForProjectsQueryKey = (projectIds)=>[
        'file-groups',
        'projectIds',
        projectIds.join(',')
    ];
export const useFileGroupsForProjectsQuery = (projectIds, options = {})=>useQuery(getFileGroupsForProjectsQueryKey(projectIds), ()=>FilesAPI.getBulkProjectFileGroups(projectIds), {
        staleTime: GENERAL_API_STALE,
        ...options
    });
export const getFileAttachementsForProjectsQueryKey = (projectIds)=>[
        'attachments',
        'projectIds',
        projectIds.join(',')
    ];
export const useFileAttachementsProjectsQuery = (projectIds, options = {})=>useQuery(getFileAttachementsForProjectsQueryKey(projectIds), ()=>FilesAPI.getBulkProjectAttachments(projectIds), {
        staleTime: GENERAL_API_STALE,
        ...options
    });
export const useInvalidateProjectFiles = ()=>{
    const queryClient = useQueryClient();
    return useCallback(async (projectId)=>{
        await queryClient.invalidateQueries({
            predicate: ({ queryKey })=>{
                if (queryKey.length !== 3) {
                    return false;
                }
                if ((queryKey[0] === 'file-groups' || queryKey[0] === 'attachments') && queryKey[1] === 'projectIds' && queryKey[2].includes(projectId.toString())) {
                    return true;
                }
                return false;
            }
        });
    }, [
        queryClient
    ]);
};
export const useCreateFileGroupMutation = (options = {})=>useMutation(({ groupName, permission, sourceId, sourceType })=>FilesAPI.createFileGroup({
            folderName: groupName,
            isPrivate: permission === 'private',
            sourceId,
            sourceType
        }), options);
export const useUploadFileMutation = (options = {})=>{
    return useMutation(({ file, data, reqConfig })=>FilesAPI.uploadFile(file, data, reqConfig), options);
};
export const useLinkFilesToProjectsMutation = (options = {})=>{
    return useMutation(({ groupId, fileIds, sourceType, sourceId, reqConfig })=>FilesAPI.linkFiles(groupId, fileIds, sourceType, sourceId, reqConfig), options);
};
export const useDeleteFileMutation = (options = {})=>{
    return useMutation(({ groupId, fileId, companyId })=>FilesAPI.deleteFile(groupId, fileId, companyId), options);
};
export const useRearrangeFilesMutation = (options = {})=>useMutation(({ sourceType, sourceId, payload })=>FilesAPI.rearrangeFiles(sourceType, sourceId, payload), options);
export const useRearrangeFoldersMutation = (options = {})=>useMutation(({ companyId, payload })=>FilesAPI.rearrangeFoldersForCompany(companyId, payload), options);
export const useDeleteFileGroupMutation = (options = {})=>{
    return useMutation(({ groupId, sourceType, sourceId })=>FilesAPI.deleteFileGroup(groupId, sourceType, sourceId), options);
};
export const useUpdateFileGroupMutation = (options = {})=>useMutation(({ formValues, groupId, sourceType, sourceId })=>FilesAPI.updateFolder(groupId, formValues, sourceType, sourceId), options);
export const usePinFileMutation = (options = {})=>useMutation((fileId)=>FilesAPI.changeFilePinnedStatus(fileId, true), options);
export const useUnpinFileMutation = (options = {})=>useMutation((fileId)=>FilesAPI.changeFilePinnedStatus(fileId, false), options);
